module services {
    export module tariff {
        export class statisticalUnitService implements interfaces.tariff.IStatisticalUnitService {
            static $inject = ["$resource", "ENV"];

            constructor(private $resource: ng.resource.IResourceService, private ENV: interfaces.applicationcore.serverConfig) {
            }

            //Gets list of all TariffCountry for a dropdown/autocomplete list
            getDropdownList(countryId: number): ng.resource.IResourceClass<interfaces.applicationcore.IDropdownModel> {

                return this.$resource<interfaces.applicationcore.IDropdownModel>(this.ENV.DSP_URL + "StatisticalUnit/GetDropdownList", {
                    countryId: countryId
                });
            }
        }
    }
    angular.module("app").service("statisticalUnitService", services.tariff.statisticalUnitService);
}